import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type DeliveryNotePartySuggestionsQueryParameters,
  type DeliveryNotePartySuggestionsResponse,
} from './types';
import {
  zodDeliveryNotePartySuggestionsParamsSchema,
  zodDeliveryNotePartySuggestionsResponseSchema,
} from './validations';

export const fetchDeliveryNotePartySuggestions = async (
  params: DeliveryNotePartySuggestionsQueryParameters,
  options?: KyRequestOptions,
) => {
  const filteredParams = Object.fromEntries(
    Object.entries({ ...params, query: params.query.trim() }).filter(
      ([, value]) => value !== undefined,
    ),
  );

  return vestigasApi
    .get(ENDPOINT.DELIVERY.GET_PARTY_SUGGESTIONS_ADMIN(), {
      searchParams: filteredParams,
      ...options,
      validate: {
        ...options?.validate,
        response: zodDeliveryNotePartySuggestionsResponseSchema,
        searchParams: zodDeliveryNotePartySuggestionsParamsSchema,
      },
    })
    .json<DeliveryNotePartySuggestionsResponse>();
};
